import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-scroll';
import StyledButton from '../common/StyledButton';

// Image d'arrière-plan par défaut, à remplacer par une image réelle plus tard
const heroImage = 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=80';

const HeroContainer = styled.section`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-image: linear-gradient(rgba(10, 10, 10, 0.7), rgba(10, 10, 10, 0.8)), url(${heroImage});
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  color: var(--text-light);
  padding: 0 var(--spacing-sm);
  
  @media (max-width: 768px) {
    background-attachment: scroll;
    min-height: 90vh;
    padding: var(--spacing-md) var(--spacing-sm);
  }
  
  @media (max-width: 480px) {
    min-height: 85vh;
    padding: var(--spacing-sm);
  }
`;

const HeroContent = styled.div`
  text-align: center;
  max-width: 900px;
  padding: var(--spacing-lg);
  z-index: 1;
  animation: fadeIn 1.5s ease-out;
  
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const HeroTitle = styled.h1`
  font-size: 4rem;
  margin-bottom: var(--spacing-md);
  font-weight: 700;
  line-height: 1.2;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  
  span {
    color: var(--accent);
  }
  
  @media (max-width: 768px) {
    font-size: 2.5rem;
    margin-bottom: var(--spacing-sm);
  }
  
  @media (max-width: 480px) {
    font-size: 2rem;
    line-height: 1.3;
  }
`;

const HeroSubtitle = styled.p`
  font-size: 1.25rem;
  margin-bottom: var(--spacing-lg);
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
  font-weight: 300;
  line-height: 1.6;
  
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: var(--spacing-md);
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: var(--spacing-sm);
    
    > * {
      width: 100%;
      max-width: 280px;
    }
  }
  
  @media (max-width: 576px) {
    gap: var(--spacing-xs);
  }
`;

const ScrollDownIndicator = styled.div`
  position: absolute;
  bottom: var(--spacing-md);
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  opacity: 0.8;
  transition: opacity var(--transition-fast);
  
  &:hover {
    opacity: 1;
  }
`;

const ScrollText = styled.span`
  font-size: 0.75rem;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

const ScrollIcon = styled.div`
  width: 1.5rem;
  height: 2.5rem;
  border: 2px solid var(--accent);
  border-radius: 1rem;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    width: 0.5rem;
    height: 0.5rem;
    background-color: var(--accent);
    border-radius: 50%;
    left: 50%;
    top: 0.5rem;
    transform: translateX(-50%);
    animation: scrollDown 2s infinite;
  }
  
  @keyframes scrollDown {
    0% {
      opacity: 1;
      transform: translateX(-50%) translateY(0);
    }
    100% {
      opacity: 0;
      transform: translateX(-50%) translateY(1rem);
    }
  }
`;

const HeroSection: React.FC = () => {
  return (
    <HeroContainer id="accueil">
      <HeroContent>
        <HeroTitle>
          Votre <span>Chauffeur Privé</span> d'Exception
        </HeroTitle>
        <HeroSubtitle>
          Fiabilité, Discrétion et Confort pour tous vos déplacements dans toute la France. 
          Un service VTC professionnel personnalisé pour vos exigences les plus élevées.
        </HeroSubtitle>
        <ButtonGroup>
          <Link to="contact" smooth={true} duration={800} offset={-100}>
            <StyledButton variant="primary" size="large">
              Réserver Maintenant
            </StyledButton>
          </Link>
          <Link to="services" smooth={true} duration={800} offset={-100}>
            <StyledButton variant="outlined" size="large">
              Découvrir Nos Services
            </StyledButton>
          </Link>
        </ButtonGroup>
      </HeroContent>
      
      <Link to="a-propos" smooth={true} duration={800} offset={-100}>
        <ScrollDownIndicator>
          <ScrollText>Découvrir</ScrollText>
          <ScrollIcon />
        </ScrollDownIndicator>
      </Link>
    </HeroContainer>
  );
};

export default HeroSection; 